import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import { PaymentCommand } from '../../../../../../../services/command';
import {
    Alert,
    Box,
    Button,
    Grid,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import Helper from '../../../../../../../utils/helper';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { OIC_DCI, oicCls } from '../orderInformationCard.classes';

const StyledCard = styled(Card)({
    maxWidth: 345,
    backgroundColor: '#f5f5f5',
    marginBottom: '5rem',
    overflow: 'auto',
});

function DigitalCardInfo({ orderId, customerId, onClose }: any) {
    const { t } = useTranslation();
    const [digitalCardResponse, setDigitalCarResponse] = useState<any>();
    const [otherPhoneNumber, setOtherPhoneNumber] = useState<any>();
    const [otherEmail, setOtherEmail] = useState<any>();
    const [openModal, setOpenModal] = useState(false);
    const [inputType, setInputType] = useState('');

    const handleOpenModal = (inputType: any) => {
        setInputType(inputType);
        setOpenModal(true);
    };
    const handleCloseModal = () => setOpenModal(false);
    const handleOtherSubmit = () => {
        if (inputType == 'sms') handleSendOtherPhoneSms();
        else if (inputType == 'email') handleSendOtherEmail();
        handleCloseModal();
    };

    const handleInputChangeForEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOtherEmail(event.target.value);
    };

    const modalBody = (
        <Box
            className={OIC_DCI.modalBox}
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
            }}
        >
            <form
                className={OIC_DCI.modalForm}
                onSubmit={(event) => {
                    event.preventDefault();
                    handleOtherSubmit();
                }}
            >
                {inputType === 'sms' ? (
                    <h4 className={OIC_DCI.modalTitle} style={{ marginBottom: '1rem', color: '#03a9f4' }}>
                        Farklı Telefon Numarasına Sms Gönderimi
                    </h4>
                ) : (
                    <h4 className={OIC_DCI.modalTitle} style={{ marginBottom: '1rem', color: '#03a9f4' }}>
                        Farklı E-Posta Adresine Mail Gönderimi
                    </h4>
                )}
                {inputType === 'sms' && (
                    <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="TR"
                        value={otherPhoneNumber}
                        onChange={setOtherPhoneNumber}
                        className={oicCls('custom-phone-input', OIC_DCI.inputPhoneOther)}
                        limitMaxLength
                        style={{ width: '100%', height: 56, borderRadius: 4 }}
                    />
                )}
                {inputType === 'email' && (
                    <TextField
                        className={OIC_DCI.inputEmailOther}
                        fullWidth
                        label="E-Posta Adresi"
                        variant="outlined"
                        value={otherEmail}
                        onChange={handleInputChangeForEmail}
                    />
                )}
                <Button
                    className={OIC_DCI.inputButtonModalSend}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2, height: '25px', color: 'white' }}
                >
                    Gönder
                </Button>
            </form>
        </Box>
    );

    useEffect(() => {
        PaymentCommand.CheckDigitalCardPayment({ orderId })
            .then((res: any) => {
                if (res) setDigitalCarResponse(res);
                else {
                    if (res.message) {
                        Swal.fire('', res.message, 'error');
                        onClose();
                    }
                    Swal.fire('', t('general.notFound'), 'error');
                    onClose();
                }
            })
            .catch(() => {
                Swal.fire('', t('general.notFound'), 'error');
                onClose();
            });
    }, []);

    const removeCountryCode = (phoneNumber: any) => {
        if (phoneNumber.startsWith('+90')) {
            return phoneNumber.slice(3);
        }
        return phoneNumber;
    };

    const handleSendSms = () => {
        let req: any = {};
        req.orderId = orderId;
        req.customerId = customerId;
        sendSmsFunc(req);
    };

    const handleSendEmail = () => {
        let req: any = {};
        req.orderId = orderId;
        req.customerId = customerId;
        sendEmailFunc(req);
    };

    const handleSendOtherPhoneSms = () => {
        let req: any = {};
        req.orderId = orderId;
        req.customerId = customerId;
        if (otherPhoneNumber) {
            if (otherPhoneNumber.toString().length < 13) {
                Swal.fire('Telefon numarasını eksik veya yanlış girdiniz');
                setOtherPhoneNumber('');
                return;
            }
            if (isValidPhoneNumber(otherPhoneNumber.toString())) {
                const formattedPhoneNumber = removeCountryCode(otherPhoneNumber);
                req.phoneNumber = formattedPhoneNumber;
            } else {
                Swal.fire('Telefon numarası uygun formatlı değil');
                setOtherPhoneNumber('');
                return;
            }
        } else {
            Swal.fire('Telefon numarası boş olamaz');
            return;
        }
        sendSmsFunc(req);
    };

    const handleSendOtherEmail = () => {
        let req: any = {};
        req.orderId = orderId;
        req.customerId = customerId;
        if (otherEmail) {
            if (Helper.validateEmail(otherEmail)) {
                req.email = otherEmail;
            } else {
                Swal.fire('Email uygun formatlı değil');
                return;
            }
        } else {
            Swal.fire('Email boş olamaz');
            return;
        }
        sendEmailFunc(req);
    };
    function sendSmsFunc(req: any) {
        PaymentCommand.SendPaymentSms(req)
            .then((res: any) => {
                if (res.status) {
                    Swal.fire(res.message, ' ', 'success');
                } else {
                    Swal.fire(res.message, ' ', 'error');
                }
            })
            .finally(() => {
                setOtherPhoneNumber('');
                onClose();
            });
    }
    function sendEmailFunc(req: any) {
        PaymentCommand.SendEmailForDigitalCard(req)
            .then((res: any) => {
                if (res.status) {
                    Swal.fire(res.message, ' ', 'success');
                } else {
                    Swal.fire(res.message, ' ', 'error');
                }
            })
            .finally(() => {
                setOtherEmail('');
                onClose();
            });
    }
    return (
        digitalCardResponse && (
            <>
                <Modal
                    className={OIC_DCI.modal}
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    {modalBody}
                </Modal>
                <StyledCard className={OIC_DCI.drawerCard}>
                    <CardContent>
                        <div
                            className={OIC_DCI.headerRow}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '1rem',
                            }}
                        >
                            <Grid
                                size={{
                                    md: 12,
                                    xs: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <CloseIcon
                                    className={oicCls('svg_icons', OIC_DCI.closeIcon)}
                                    onClick={onClose}
                                    style={{ cursor: 'pointer', float: 'right' }}
                                />
                            </Grid>
                        </div>
                        <Typography className={OIC_DCI.title} gutterBottom variant="h5" component="div">
                            {t('orderDetail.giftCardInfo')}
                        </Typography>
                        {digitalCardResponse.digitalCardDto && (
                            <TableContainer className={OIC_DCI.tableContainer} component={Paper}>
                                <Table className={OIC_DCI.table}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.cardNumber')}</TableCell>
                                            <TableCell>{digitalCardResponse.digitalCardDto?.cardNumber}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.serialNumber')}</TableCell>
                                            <TableCell>{digitalCardResponse.digitalCardDto?.serialNumber}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.activationStatus')}</TableCell>
                                            <TableCell>
                                                {digitalCardResponse.digitalCardDto?.isActive ? 'Aktif' : 'Pasif'}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.balance')}</TableCell>
                                            <TableCell>{`${digitalCardResponse.digitalCardDto?.balance} TL`}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.expirationDate')}</TableCell>
                                            <TableCell>{digitalCardResponse.digitalCardDto?.expirationDate}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.creationDate')}</TableCell>
                                            <TableCell>{digitalCardResponse.digitalCardDto?.createdDate}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('orderDetail.orderID')}</TableCell>
                                            <TableCell>{digitalCardResponse.digitalCardDto?.cardOrderId}</TableCell>
                                        </TableRow>
                                        {digitalCardResponse.digitalCardDto?.email && (
                                            <TableRow>
                                                <TableCell>{t('general.email')}</TableCell>
                                                <TableCell>{digitalCardResponse.digitalCardDto?.email}</TableCell>
                                            </TableRow>
                                        )}
                                        {digitalCardResponse.digitalCardDto?.phoneNumber && (
                                            <TableRow>
                                                <TableCell>{t('general.phone')}</TableCell>
                                                <TableCell>{digitalCardResponse.digitalCardDto?.phoneNumber}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                        {digitalCardResponse.digitalCardDto?.imageUrl && (
                            <CardMedia
                                className={OIC_DCI.cardImage}
                                component="img"
                                height="140"
                                image={digitalCardResponse.digitalCardDto.imageUrl}
                                style={{ marginTop: '20px' }}
                            />
                        )}

                        {digitalCardResponse.status && (
                            <div className={OIC_DCI.actionsColumn} style={{ display: 'flex', flexDirection: 'column' }}>
                                {digitalCardResponse.digitalCardDto.phoneNumber && (
                                    <Button
                                        className={OIC_DCI.inputButtonSms}
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSendSms}
                                        sx={{ height: '30px', margin: '15px 0px 10px 0px' }}
                                        fullWidth
                                    >
                                        SMS Gönder
                                    </Button>
                                )}
                                {digitalCardResponse.digitalCardDto.email && (
                                    <Button
                                        className={OIC_DCI.inputButtonMail}
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSendEmail}
                                        fullWidth
                                        sx={{ height: '30px', margin: '15px 0px 10px 0px' }}
                                    >
                                        Mail Gönder
                                    </Button>
                                )}
                                <Button
                                    className={OIC_DCI.inputButtonSmsOther}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleOpenModal('sms')}
                                    sx={{ height: '30px', margin: '15px 0px 10px 0px' }}
                                    fullWidth
                                >
                                    Farklı Telefon Numarasına SMS Gönder
                                </Button>
                                <Button
                                    className={OIC_DCI.inputButtonMailOther}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleOpenModal('email')}
                                    sx={{ height: '30px', margin: '15px 0px 10px 0px' }}
                                    fullWidth
                                >
                                    Farklı E-Posta Adresine Mail Gönder
                                </Button>
                            </div>
                        )}
                        {!digitalCardResponse.status && (
                            <div className={OIC_DCI.warningWrap} style={{ marginTop: '1rem' }}>
                                <Alert className={OIC_DCI.warningAlert} severity="warning">
                                    <p style={{ fontSize: '16px' }}>{digitalCardResponse.message}</p>
                                </Alert>
                            </div>
                        )}
                    </CardContent>
                </StyledCard>
            </>
        )
    );
}

export default DigitalCardInfo;
